import { useWeb3Context } from 'src/context/web3';
import { notify } from 'src/utils/notify';

import useAuthReducer from '../reducers/useAuthReducer';
import { useXellarUpdateChain } from '../xellar/useXellar';
import { IWeb3modalChain, web3modalChains } from './useWeb3Client';

const ALERT_WALLET_NOT_CONNECTED = 'Please connect your wallet!';

const ALERT_NETWORK_SWITCHED = (text: string) => `You have succefully switched to ${text}`;

export default function useChangeNetwork() {
	const { mutate: updateChain, isLoading: isLoadingUpdateChain } = useXellarUpdateChain();
	const { clearUserProfile } = useAuthReducer();
	const { provider, isXellar: xellarConnected, isConnected: walletConnected } = useWeb3Context();

	const changeNetwork = async (selectedChain: number) => {
		if (!walletConnected && !xellarConnected) {
			notify(ALERT_WALLET_NOT_CONNECTED, 'error');
			return;
		}

		let selectedChainData: IWeb3modalChain | undefined;

		try {
			if (xellarConnected) {
				updateChain(
					{ chain_id: selectedChain },
					{
						onSuccess: (res: any) => {
							if (res.status === 200) {
								selectedChainData = web3modalChains?.find(
									({ chainId }: IWeb3modalChain) => chainId === selectedChain,
								);

								notify(ALERT_NETWORK_SWITCHED(selectedChainData?.name || ''), 'success', {
									onClose: () => window.location.reload(),
									duration: 0.5,
								});

								clearUserProfile();
							} else {
								notify(res?.data?.message ?? 'Failed to switch chain', 'error');
							}
						},
					},
				);
			} else {
				await provider.request({
					method: 'wallet_switchEthereumChain',
					params: [{ chainId: `0x${selectedChain.toString(16)}` }],
				});

				selectedChainData = web3modalChains?.find(
					({ chainId }: IWeb3modalChain) => chainId === selectedChain,
				);

				notify(ALERT_NETWORK_SWITCHED(selectedChainData?.name || ''));
			}
		} catch (switchError: any) {
			notify('This network is not available', 'error');
		}
	};

	return { changeNetwork, loading: isLoadingUpdateChain };
}
